import Controller from '@ember/controller';
import { action } from '@ember/object';
import { service } from '@ember/service';

export default class FourOFourController extends Controller {
  @service router;
  @service intl;
  get randomMessage() {
    return this.intl.t(
      `four-o-four-messages.heading.heading-${Math.floor(Math.random() * 3) + 1}`,
    );
  }

  @action
  goBack() {
    this.router.transitionTo('planning.dashboard.overview.grid');
  }
}
